<template>
  <!-- Layout Footer -->
  <a-layout-footer>
    <a-row type="flex"> </a-row>
  </a-layout-footer>
  <!-- / Layout Footer -->
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
